import { Typography } from "@material-ui/core";

import MeditocPopover from "../../../utils/MeditocPopover";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function HelperConsulta() {
    const {
        popoverConsulta,
        handleChangePopoverConsulta
    } = useCallCenter();

    return (
        <MeditocPopover open={popoverConsulta} setopen={handleChangePopoverConsulta}>
            <Typography variant="body2" paragraph>
                SE HA CAMBIADO TU ESTATUS A OCUPADO.
            </Typography>
            <Typography variant="body2" paragraph>
                Un paciente ha entrado a tu sala pero <br />
                aún no has iniciado la consulta.
            </Typography>
        </MeditocPopover>
    );
}
